import { VitrinsPage } from 'pageModules/VitrinsPage';

export default VitrinsPage;
